import { css, styled } from 'styled-components';
import { Button as KendoButton } from '@progress/kendo-react-buttons';
import { EColor } from '../../../themes/constants';
import { TVariant } from './FormButton.types';

export const StyledButton = styled(KendoButton)<{ variant?: TVariant }>`
  &.k-button {
    ${({ variant }) => {
      switch (variant) {
        case 'secondary':
          return css`
            padding-block: 8px;
            padding-inline: 12px;
            background-color: ${EColor.LIGHT_GRAY};
            border-color: ${EColor.LIGHT_GRAY};
            color: ${EColor.BLACK};
          `;
        case 'tertiary':
          return css`
            background-color: var(--color-tertiary);
            border-color: var(--color-tertiary);
            color: var(--color-white);
          `;
        case 'icon-grid-btn':
          return css`
            width: 25px;
            height: 25px;
            background-color: #fff;
            border: 1px solid rgb(204, 204, 204);
            border-radius: 3px;
            cursor: pointer;
            appearance: none;
            outline: none;
            color: #333;
          `;

        default:
          return css`
            width: 75px;
            padding-block: 5.5px;
            padding-inline: 12px;
            background-color: ${EColor.SKY_BLUE};
            border-color: ${EColor.SKY_BLUE};
            color: ${EColor.WHITE};
            text-transform: uppercase;
            overflow: hidden;

            .k-button-text {
              position: relative;
              line-height: 22px;
              height: 22px;
            }

            &:focus {
              background-color: ${EColor.ORANGE};
              border-color: ${EColor.ORANGE};
              .btn-focus {
                display: block;
              }
            }

            &:active {
              background-color: ${EColor.SKY_BLUE};
              border-color: ${EColor.SKY_BLUE};
            }

            &.k-button:disabled,
            .k-button.k-disabled {
              opacity: 1;
            }
          `;
      }
    }}

    &:hover {
      ${({ variant }) => {
        switch (variant) {
          case 'secondary':
            return css`
              filter: brightness(0.9);
            `;
          case 'tertiary':
            return css`
              filter: brightness(0.9);
            `;
          case 'icon-grid-btn':
            return css`
              // background-color: rgba(204, 204, 204, 1);
              background-color: #fff;
              border-color: rgb(44, 80, 152);
              color: rgb(44, 80, 152);
            `;

          default:
            return css`
              filter: brightness(0.9);
            `;
        }
      }}
    }
  }
`;
